import observer from 'saddlebag-observer';

const GRAPPLER_EVENT = 'grappler-track';

export const EVENT_NAMES = {
  INTERACTION: 'InteractionEvent',
  FUNNEL: 'funnel_events',
} as const;

type EventName = (typeof EVENT_NAMES)[keyof typeof EVENT_NAMES];

type InteractionEventParams = {
  name: string;
  eventName?: EventName;
  strings?: Record<string, string>;
  numbers?: Record<string, number>;
  bools?: Record<string, boolean>;
};

export const trackInteractionEvent = ({
  bools = {},
  eventName = EVENT_NAMES.INTERACTION,
  name,
  numbers = {},
  strings = {},
}: InteractionEventParams) => {
  observer.publish(GRAPPLER_EVENT, {
    isMiniEvent: true, // Required for commons.MiniHeader
    consentRequired: true,
    eventName,
    fullSchemaName: 'tallyman.InteractionEvent',
    // tallyman schema acceptable for use in other services
    // https://github.com/Skyscanner/schemas/pull/3821#issuecomment-3811579090
    message: {
      name,
      strings: {
        ...strings,
      },
      numbers: {
        ...numbers,
      },
      bools: {
        ...bools,
      },
    },
  });
};
